import React from 'react'
import Styles from './MarketingExperience.module.scss'
import CardButton from 'blaze-ui/CardButton/CardButton'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { MultiStepStepProps } from 'components/MultiStepFlow/Types'
import { useQueryParams } from 'hooks/useQueryParams'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useSelectionHandler } from 'components/FirstTimeExperienceModal/hooks/useSelectionHandler'
import { useOnboardingTracking } from 'hooks/useOnboardingTracking'

const MARKETING_EXPERIENCE_ASSETS: Record<string, string> = {
  0: 'https://res.cloudinary.com/almanac/image/upload/v1740090706/onboarding_assets/marketing_experience/image_pocxqb.png',
  1: 'https://res.cloudinary.com/almanac/image/upload/v1740090706/onboarding_assets/marketing_experience/image-1_eyss18.png',
  2: 'https://res.cloudinary.com/almanac/image/upload/v1740090706/onboarding_assets/marketing_experience/image-2_ylx1sm.png',
  3: 'https://res.cloudinary.com/almanac/image/upload/v1740090707/onboarding_assets/marketing_experience/image-3_gcejmt.png',
}

export const marketingExperienceOptions = [
  {
    title: 'Just started',
    description: "I'm new to marketing",
    value: 0,
  },
  {
    title: 'Learning the ropes',
    description: "I've got things started",
    value: 1,
  },
  {
    title: 'Getting results',
    description: "I've got things working",
    value: 2,
  },
  {
    title: 'Marketing pro',
    description: "I'm ready to scale",
    value: 3,
  },
]

export const MarketingExperience: React.FC<MultiStepStepProps> = ({ onNext, onBack }) => {
  const { templateId, aspectRatioKey } = useQueryParams()
  const { isMobile } = useResponsiveDesign()
  const { trackMarketingExperienceLevelSelected } = useOnboardingTracking()
  const { selectedValue, handleNext, handleSelection } = useSelectionHandler<string>({
    paramName: 'marketingExperienceLevel',
    dataKey: 'marketingExperienceLevel',
    onNext,
    generateEvent: () => (templateId && aspectRatioKey ? { type: 'CREATE_CONTENT' } : undefined),
  })

  return (
    <MultiStepStepLayout
      title="How would you describe your marketing experience?"
      onBack={isMobile ? undefined : onBack}
      onNext={isMobile ? undefined : handleNext}
      isNextButtonDisabled={!selectedValue}
      scrollContainerClassName={Styles.scrollContainer}
    >
      <div className={Styles.options}>
        {marketingExperienceOptions.map((option) => {
          return (
            <CardButton
              key={option.value}
              subLabel={option.description}
              label={option.title}
              variant="list"
              onPress={() => {
                handleSelection(option.value.toString())
                trackMarketingExperienceLevelSelected(option.title)
              }}
              media={
                <img src={MARKETING_EXPERIENCE_ASSETS[option.value]} alt={option.title} className={Styles.image} />
              }
              isSelected={selectedValue === option.value.toString()}
            />
          )
        })}
      </div>
    </MultiStepStepLayout>
  )
}

export default MarketingExperience
